import React from 'react'

const WebEdge = () => {
  return (
    <div>WebEdge</div>
  )
}

export default WebEdge